(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-index"] && !Shopify.designMode) return;
  try {
    
class BlogIndexCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-blog-track]');
    var prevBtn = this.querySelector('[data-blog-prev]');
    var nextBtn = this.querySelector('[data-blog-next]');
    var self = this;
    if (prevBtn) prevBtn.addEventListener('click', function () { self.scrollByPage(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { self.scrollByPage(1); });
  }
  scrollByPage(dir) {
    if (!this.track) return;
    this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'instant' });
  }
}
if (!customElements.get('blog-index-carousel')) {
  customElements.define('blog-index-carousel', BlogIndexCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["facets"]) return;
  try {
    
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    const toggle = this.querySelector('.m-facets__toggle');
    if (toggle) {
      toggle.addEventListener('click', () => {
        const open = this.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open);
      });
    }
    this.form.addEventListener('input', (event) => {
      if (event.target.matches('input[type="checkbox"], input[type="range"]')) {
        this.onSubmitHandler();
      }
    });
    const sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => this.onSubmitHandler());
    }
  }
  onSubmitHandler() {
    const formData = new FormData(this.form);
    const sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) formData.set('sort_by', sortSelect.value);
    const params = new URLSearchParams(formData).toString();
    window.location.href = `${window.location.pathname}?${params}`;
  }
}
customElements.define('facet-filters-form', FacetFiltersForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.m-featprod__thumbs').forEach((wrap) => {
  const main = wrap.closest('.m-featprod').querySelector('#featprod-main-image');
  wrap.querySelectorAll('.m-featprod__thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      wrap.querySelectorAll('.m-featprod__thumb').forEach((t) => t.classList.remove('is-selected'));
      thumb.classList.add('is-selected');
      if (main) main.src = thumb.dataset.full;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
class GoogleReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.placeId = this.dataset.placeId;
    this.loadingEl = this.querySelector('[data-reviews-loading]');
    this.slidesEl = this.querySelector('[data-reviews-slides]');
    this.track = this.querySelector('[data-reviews-track]');
    var prevBtn = this.querySelector('[data-reviews-prev]');
    var nextBtn = this.querySelector('[data-reviews-next]');
    var self = this;
    if (prevBtn) prevBtn.addEventListener('click', function () { self.scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { self.scrollByCard(1); });
    if (!this.placeId || !window.MassivoPlaces) return;
    window.MassivoPlaces.whenReady(function () { self.fetchReviews(); });
  }
  scrollByCard(dir) {
    if (!this.track) return;
    this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'instant' });
  }
  fetchReviews() {
    var service = new google.maps.places.PlacesService(document.createElement('div'));
    var self = this;
    service.getDetails({ placeId: this.placeId, fields: ['reviews'], language: 'es' }, function (place, status) {
      if (status !== google.maps.places.PlacesServiceStatus.OK || !place || !place.reviews || !place.reviews.length) {
        if (self.loadingEl) self.loadingEl.textContent = 'Aún no hay suficientes reseñas de Google para mostrar aquí.';
        return;
      }
      self.render(place.reviews.slice(0, 5));
    });
  }
  render(reviews) {
    if (this.loadingEl) this.loadingEl.hidden = true;
    var self = this;
    reviews.forEach(function (review) {
      var el = document.createElement('div');
      el.className = 'm-greviews__card';
      var rounded = Math.round(review.rating || 0);
      var stars = '★★★★★☆☆☆☆☆'.slice(5 - rounded, 10 - rounded);
      var initial = (review.author_name || '?').trim().charAt(0).toUpperCase();
      var avatar = review.profile_photo_url
        ? '<img src="' + review.profile_photo_url + '" alt="" class="m-greviews__avatar" loading="lazy" referrerpolicy="no-referrer">'
        : '<span class="m-greviews__avatar">' + initial + '</span>';
      el.innerHTML =
        '<div class="m-greviews__card-head">' + avatar +
          '<div class="m-greviews__card-headtext"><p class="m-greviews__card-name"></p><p class="m-greviews__card-time"></p></div>' +
          '<span class="m-greviews__card-glogo"></span>' +
        '</div>' +
        '<div class="m-greviews__card-stars" aria-hidden="true">' + stars + '</div>' +
        '<p class="m-greviews__card-text"></p>' +
        '<button type="button" class="m-greviews__more" hidden>Mostrar más</button>';
      el.querySelector('.m-greviews__card-name').textContent = review.author_name || '';
      el.querySelector('.m-greviews__card-time').textContent = review.relative_time_description || '';
      el.querySelector('.m-greviews__card-text').textContent = review.text || '';
      self.slidesEl.appendChild(el);

      var glogo = el.querySelector('.m-greviews__card-glogo');
      glogo.innerHTML = self.googleGSvg();

      var textEl = el.querySelector('.m-greviews__card-text');
      var moreBtn = el.querySelector('.m-greviews__more');
      requestAnimationFrame(function () {
        if (textEl.scrollHeight > textEl.clientHeight + 2) {
          moreBtn.hidden = false;
          moreBtn.addEventListener('click', function () {
            var expanded = textEl.classList.toggle('is-expanded');
            moreBtn.textContent = expanded ? 'Mostrar menos' : 'Mostrar más';
          });
        }
      });
    });
  }
  googleGSvg() {
    return '<svg width="15" height="15" viewBox="0 0 48 48" aria-hidden="true"><path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"/><path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"/><path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34A21.94 21.94 0 0 0 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z"/><path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z"/></svg>';
  }
}
if (!customElements.get('google-reviews-carousel')) {
  customElements.define('google-reviews-carousel', GoogleReviewsCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class MegaMenu extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.m-megamenu__trigger');
    this.panel = this.querySelector('.m-megamenu__panel');
    this.trigger.addEventListener('click', () => this.toggle());
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
    this.querySelectorAll('.m-megamenu__row').forEach((row) => {
      row.addEventListener('click', () => this.close());
    });
  }
  toggle() {
    const isOpen = !this.panel.hidden;
    isOpen ? this.close() : this.open();
  }
  open() {
    this.panel.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
  }
  close() {
    this.panel.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
  }
}
customElements.define('mega-menu', MegaMenu);

document.addEventListener('DOMContentLoaded', () => {
  const searchToggle = document.querySelector('.m-header__search-toggle');
  const searchBar = document.querySelector('.m-header__searchbar');
  if (searchToggle && searchBar) {
    const setSearch = (open) => {
      searchBar.hidden = !open;
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) searchBar.querySelector('input[type="search"]').focus();
    };
    searchToggle.addEventListener('click', () => setSearch(searchBar.hidden));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !searchBar.hidden) { setSearch(false); searchToggle.focus(); }
    });
  }
  const burger = document.querySelector('.m-header__burger');
  const drawer = document.querySelector('.m-header__drawer');
  if (burger && drawer) {
    burger.addEventListener('click', () => {
      const isOpen = drawer.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductDetail extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.dataset.productJson);
    this.selectedOptions = [...(this.variants[0]?.options || [])];
    const current = this.variants.find((v) => v.id === Number(this.querySelector('[data-add-to-cart]')?.dataset.variantId));
    if (current) this.selectedOptions = [...current.options];

    this.mainImage = this.querySelector('#main-product-image');
    this.priceEl = this.querySelector('[data-price]');
    this.addButton = this.querySelector('[data-add-to-cart]');
    this.selectedColorEl = this.querySelector('[data-selected-color]');

    this.querySelectorAll('.m-product__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.querySelectorAll('.m-product__thumb').forEach((t) => t.classList.remove('is-selected'));
        thumb.classList.add('is-selected');
        this.setMainImage(thumb.dataset.full);
      });
    });

    this.querySelectorAll('.m-product__swatch').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const index = Number(swatch.dataset.optionIndex);
        this.selectedOptions[index] = swatch.dataset.value;
        this.querySelectorAll('.m-product__swatch').forEach((s) => {
          if (Number(s.dataset.optionIndex) === index) s.classList.remove('is-selected');
        });
        swatch.classList.add('is-selected');
        if (this.selectedColorEl) this.selectedColorEl.textContent = swatch.dataset.value;
        this.updateVariant();
      });
    });

    const minus = this.querySelector('[data-qty-minus]');
    const plus = this.querySelector('[data-qty-plus]');
    const qtyInput = this.querySelector('[data-quantity-input]');
    if (minus && plus && qtyInput) {
      minus.addEventListener('click', () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
      plus.addEventListener('click', () => {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });
    }
  }

  updateVariant() {
    const match = this.variants.find((v) =>
      v.options.every((opt, i) => opt === this.selectedOptions[i])
    );
    if (!match) return;
    if (this.priceEl) {
      this.priceEl.textContent = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0 }).format(match.price / 100);
    }
    if (this.addButton) {
      this.addButton.dataset.variantId = match.id;
      this.addButton.disabled = !match.available;
      this.addButton.textContent = match.available ? 'Agregar al carrito' : 'Agotado';
    }
    this.showVariantImage(match);
  }

  // image_tag renders a srcset, which browsers prefer over src, so both must be reset.
  setMainImage(url, alt) {
    if (!this.mainImage || !url) return;
    this.mainImage.removeAttribute('srcset');
    this.mainImage.removeAttribute('sizes');
    this.mainImage.src = url;
    if (alt) this.mainImage.alt = alt;
  }

  showVariantImage(variant) {
    const thumbs = [...this.querySelectorAll('.m-product__thumb')];
    let url = null;
    let alt = null;
    if (variant.featured_image && variant.featured_image.src) {
      const u = new URL(variant.featured_image.src, location.origin);
      u.searchParams.set('width', '800');
      url = u.toString();
      alt = variant.featured_image.alt;
    } else {
      // Fallback: a gallery image whose alt text mentions the selected color.
      const color = (this.selectedColorEl?.textContent || '').trim().toLowerCase();
      const hit = color && thumbs.find((t) => (t.querySelector('img')?.alt || '').toLowerCase().includes(color));
      if (hit) url = hit.dataset.full;
    }
    if (!url) return;
    this.setMainImage(url, alt);
    const base = (u) => u.split('?')[0];
    thumbs.forEach((t) => t.classList.toggle('is-selected', base(t.dataset.full) === base(url)));
  }
}
customElements.define('product-detail', ProductDetail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-products"] && !Shopify.designMode) return;
  try {
    
class PopularProductsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-popprod-track]');
    var prevBtn = this.querySelector('[data-popprod-prev]');
    var nextBtn = this.querySelector('[data-popprod-next]');
    var self = this;
    if (prevBtn) prevBtn.addEventListener('click', function () { self.scrollByPage(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { self.scrollByPage(1); });
  }
  scrollByPage(dir) {
    if (!this.track) return;
    this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'instant' });
  }
}
if (!customElements.get('popular-products-carousel')) {
  customElements.define('popular-products-carousel', PopularProductsCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
class TestimonialCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.m-testi__slide')];
    this.counter = this.querySelector('[data-testi-current]');
    this.index = 0;
    this.interval = parseInt(this.dataset.interval, 10) || 6500;
    this.querySelector('[data-testi-prev]').addEventListener('click', () => this.go(this.index - 1));
    this.querySelector('[data-testi-next]').addEventListener('click', () => this.go(this.index + 1));
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!this.reducedMotion) this.start();
  }
  start() {
    if (this.reducedMotion) return;
    this.stop();
    this.timer = setInterval(() => this.go(this.index + 1), this.interval);
  }
  stop() {
    clearInterval(this.timer);
  }
  go(next) {
    const total = this.slides.length;
    this.index = (next + total) % total;
    this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
    if (this.counter) this.counter.textContent = String(this.index + 1).padStart(2, '0');
  }
  disconnectedCallback() {
    this.stop();
  }
}
customElements.define('testimonial-carousel', TestimonialCarousel);

  } catch(e) { console.error(e); }
})();
})();
